export const ArrowTurnIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.63039 8.03605C6.37143 8.0337 6.11173 8.13131 5.91414 8.3289C5.90918 8.33386 5.90429 8.33885 5.89946 8.34389L2.37891 11.8644L3.79312 13.2787L5.62401 11.4478C5.59806 12.6422 5.8399 13.8331 6.33869 14.9309C7.01941 16.4291 8.1456 17.6809 9.56373 18.5157C10.9819 19.3505 12.6229 19.7277 14.2632 19.5958C15.9035 19.464 17.4633 18.8295 18.7298 17.7788C19.9964 16.7281 20.9081 15.3125 21.3407 13.7248C21.7733 12.137 21.7058 10.4545 21.1473 8.9066C20.5889 7.35866 19.5666 6.0206 18.22 5.07483C16.8733 4.12905 15.2677 3.62158 13.6221 3.62158L13.6221 5.62158C14.8563 5.62158 16.0605 6.00218 17.0705 6.71152C18.0805 7.42085 18.8472 8.42439 19.266 9.58534C19.6849 10.7463 19.7355 12.0082 19.4111 13.199C19.0866 14.3897 18.4028 15.4515 17.4529 16.2395C16.503 17.0275 15.3332 17.5034 14.103 17.6023C12.8727 17.7012 11.6419 17.4183 10.5783 16.7922C9.51473 16.1661 8.67009 15.2272 8.15955 14.1036C7.7802 13.2687 7.59902 12.3619 7.62448 11.4535L9.44967 13.2786L10.8639 11.8644L7.34319 8.34374C7.33841 8.33876 7.33356 8.33381 7.32865 8.3289C7.13564 8.13589 6.88336 8.03827 6.63039 8.03605Z"
				fill="currentColor"
			/>
		</svg>
	);
};
